import React from 'react';
import PropTypes from 'prop-types';
import { TableCell, Tooltip, TableSortLabel } from '@material-ui/core';

const OrderedColumnHeader = ({ title, order, orderBy, propertyName, numeric, onChangeSort, ...rest }) => (
  <TableCell
    {...rest}
    sortDirection={order}
    align={numeric ? 'right' : 'left'}>
    <Tooltip
      title="Sortuj"
      enterDelay={300}
      placement={numeric ? 'bottom-end' : 'bottom-start'}>
      <TableSortLabel
        active={orderBy === propertyName}
        direction={order}
        onClick={() => onChangeSort(propertyName)}
      >
        {title}
      </TableSortLabel>
    </Tooltip>
  </TableCell>
);

OrderedColumnHeader.propTypes = {
  title: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  propertyName: PropTypes.string.isRequired,
  order: PropTypes.string.isRequired,
  numeric: PropTypes.bool,
  onChangeSort: PropTypes.func.isRequired,
};

export default OrderedColumnHeader;



// WEBPACK FOOTER //
// ./src/components/budget/OrderedColumnHeader.js